export default "__VITE_PUBLIC_ASSET__018e5571__"